import styled from 'styled-components'

export const FormContainerStyles = styled.div`
  margin: -2rem;
  padding: 2rem;
`
